import moment from "moment";
import axios from "axios";
import { encode } from "base-64";
import fileDownload from "js-file-download";

export function capitalizeFirstLetter(string) {
  if (string && typeof string === "string" && string !== "") {
    string = string.toLowerCase();
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  return "";
}

export function removeUnderScore(string, extraString = "", extraTo = "") {
  if (extraString !== "") {
    string = string.replace(extraString, extraTo);
  }
  return string.replace(/_/g, " ");
}

export function transformErrorMessage(string, extraString = "", extraTo = "") {
  return string.indexOf("NaN") > -1
    ? "Please enter a valid number"
    : removeUnderScore(string, extraString, extraTo);
}

export function truncateString(str, n) {
  return str.length > n ? str.substr(0, n - 1) + ".." : str;
}

function replaceDateStringFrom(date) {
  let res = undefined;
  try {
    if (date && typeof date === "string" && date !== "") {
      res = date.replace("/Date(", "");
      res = res.replace(")/", "");
      res = moment(parseInt(res));
    }
  } catch (e) {}
  return res;
}

export function getUnixDateFormat(dateNum, format = "MMMM D, yyyy") {
  let res = "N/A";
  const getDate = replaceDateStringFrom(dateNum);
  if (getDate && getDate !== undefined) {
    res = getDate.format(format);
  }
  return res;
}

export function nFormatter(num) {
  if (num >= 1000000000) {
    return (num / 1000000000).toFixed(1).replace(/\.0$/, "") + "G";
  }
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1).replace(/\.0$/, "") + "K";
  }
  return num;
}

export function checkNegNum(num) {
  return parseFloat(num) < 0;
}

export function makeNegToPosNum(num) {
  return -1 * parseFloat(num);
}

export function setPageDetails(data = {}) {
  if (data.title) {
    document.title = data.title;
  }
  if (data.favIcon) {
    document.getElementById("fav-icon").setAttribute("href", data.favIcon);
    document
      .getElementById("apple-touch-icon")
      .setAttribute("href", data.favIcon);
  }
}

export function addStyle(url) {
  const head = document.body.parentElement.firstElementChild;
  const style = document.createElement("link");
  style.setAttribute("href", url);
  style.setAttribute("id", "main-style-sheet");
  style.setAttribute("rel", "stylesheet");
  style.setAttribute("async", true);
  head.appendChild(style);
}

export function changeStyle(url, id = "main-style-sheet") {
  if (document.getElementById(id))
    document.getElementById(id).setAttribute("href", url);
}

export function pluckArray(arr, key) {
  return arr.map((i) => i[key]);
}

export function getSessionStorageOrDefault(key, defaultValue) {
  const stored = sessionStorage.getItem(key);
  if (!stored) {
    return defaultValue;
  }
  return JSON.parse(stored);
}

export function getRandomString() {
  return (
    Math.random().toString(36).substring(2, 15) +
    Math.random().toString(36).substring(2, 15)
  );
}

export function getUniTimeString() {
  const millis = Date.now();
  const time = millis / 1000;
  return time;
}

export function deepCopy(obj) {
  return JSON.parse(JSON.stringify(obj));
}

export function checkArray(arr, res = true, val = false) {
  return arr && Array.isArray(arr) && arr.length > 0 ? res : val;
}

export function createSelectOptions(arr, value = "id", label = "name") {
  let res = null;
  if (checkArray(arr)) {
    res = arr.map((item, inx) => {
      if (typeof item == "object") {
        return (
          <option value={item?.[value]} key={inx}>
            {item?.[label]}
          </option>
        );
      } else {
        return (
          <option value={inx} key={inx}>
            {item}
          </option>
        );
      }
    });
  } else if (checkNull(arr) && typeof arr === "object") {
    res = Object.keys(arr).map((item, inx) => (
      <option value={item} key={inx}>
        {arr?.[item]}
      </option>
    ));
  }
  return res;
}
export function createSelectTwoOptions(arr, value = "id", label = "name") {
  let res = [];
  if (checkArray(arr)) {
    res = arr.map((item, inx) => {
      if (typeof item == "object") {
        return { text: item?.[label], id: item?.[value] };
      } else {
        return { text: item, id: inx };
      }
    });
  } else if (checkNull(arr) && typeof arr === "object") {
    res = Object.keys(arr).map((item, inx) => ({
      text: arr?.[item],
      id: item,
    }));
  }
  return res;
}

export function createMultiSelectOptions(arr, value = "id", label = "name") {
  let res = [];
  if (checkArray(arr)) {
    res = arr.map((item, inx) => ({
      label: item?.[label],
      value: item?.[value],
    }));
    res = arr.map((item, inx) => {
      if (typeof item == "object") {
        return {
          label: item?.[label],
          value: item?.[value],
        };
      } else {
        return { label: item, value: inx };
      }
    });
  } else if (checkNull(arr) && typeof arr === "object") {
    res = Object.keys(arr).map((item, inx) => ({
      label: arr?.[item],
      value: item,
    }));
  }
  return res;
}

export function createYesNoSelectOptions(type = "text") {
  let res = null;
  if (type == "text") {
    let arr = { yes: "Yes", no: "No" };
    res = Object.keys(arr).map((item, inx) => (
      <option value={item} key={inx}>
        {arr?.[item]}
      </option>
    ));
  } else {
    let arr = { 1: "Yes", 0: "No" };
    res = Object.keys(arr).map((item, inx) => (
      <option value={item} key={inx}>
        {arr?.[item]}
      </option>
    ));
  }
  return res;
}

export function getFormData(object, formData = new FormData()) {
  if (object && typeof object === "object") {
    console.log("yesss");
    Object.keys(object).forEach((key) => formData.append(key, object[key]));
  }
  return formData;
}
export function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

export function getFileNameFromUrl(url) {
  let res = "";
  if (checkNull(url, false)) {
    const checkUrl = url.split("/");
    if (checkUrl.length) {
      res = checkUrl[checkUrl.length - 1];
    }
  }
  return res;
}

export const isPastFromToday = (date, includeToday = false) => {
  let res;
  if (checkNull(date, false)) {
    try {
      if (includeToday) res = moment(date).isSameOrBefore(moment(), "day");
      else res = moment(date).isBefore(moment(), "day");
    } catch (error) {}
  }
  return res;
};

export const isFutureFromToday = (date, includeToday = false) => {
  let res;
  if (checkNull(date, false)) {
    try {
      if (includeToday) res = moment(date).isSameOrAfter(moment(), "day");
      else res = moment(date).isAfter(moment(), "day");
    } catch (error) {}
  }
  return res;
};

export function parseStringToDate(
  date,
  from = "yyyy-MM-DD HH:mm:ss",
  to = "yyyy-MM-DD"
) {
  let res = undefined;
  try {
    if (date && typeof date === "string" && date !== "") {
      res = moment(date, from).format(to);
    }
  } catch (e) {}
  return res;
}

export function checkNull(string, val = "") {
  if (typeof string == "number") {
    string = string.toString();
  }

  return string && string !== "" && string !== null ? string : val;
}

export function changeDateFormat(string, format = "DD-MM-yyyy", val = "") {
  let res = val;
  if (string && string !== "" && string !== null) {
    try {
      res = moment(string).format(format);
    } catch (error) {}
  }
  return res;
}
export const isNumeric = (num) =>
  (typeof num === "number" || (typeof num === "string" && num.trim() !== "")) &&
  !isNaN(num);

export function decimalValue(value, decimal = 2, currency = "$") {
  let res = "";
  const resVal =
    value && isNumeric(value) ? parseFloat(value, decimal).toFixed() : "0.00";
  // console.log("testtttttt", resVal, value);
  if (resVal) {
    res = `${currency}${resVal}`;
  }
  return res;
}

export function downloadableFileFromUrl(url, filename) {
  // var win = window.open(url, "_blank");
  // return win.focus();
  const uninterceptedAxiosInstance = axios.create();
  return uninterceptedAxiosInstance
    .get(url, {
      responseType: "blob",
    })
    .then((res) => {
      fileDownload(res.data, filename);
    })
    .catch((err) => {
      console.log("downloadFileFromUrl:", err);
      alert("Unable to process your request!");
    });
}

export function downloadFileFromUrl(url, filename) {
  var win = window.open(url, "_blank");
  return win.focus();
  const uninterceptedAxiosInstance = axios.create();
  return uninterceptedAxiosInstance
    .get(url, {
      responseType: "blob",
    })
    .then((res) => {
      fileDownload(res.data, filename);
    })
    .catch((err) => {
      console.log("downloadFileFromUrl:", err);
      alert("Unable to process your request!");
    });
}

export function parseStringToFloat(num, to = 2) {
  let res = 0;
  try {
    if (num && num !== null) {
      const parseNum = parseFloat(num);
      if (parseNum) {
        res = parseNum.toFixed(to);
      }
    }
  } catch (e) {}
  return res;
}

export function groupByArray(objectArray, property) {
  return objectArray.reduce((acc, obj) => {
    const key = obj[property];
    if (!acc[key]) {
      acc[key] = [];
    }
    // Add object to list for given key's value
    acc[key].push(obj);
    return acc;
  }, {});
}

export const imageExists = (url) =>
  new Promise(function (resolve, reject) {
    var img = new Image();
    img.src = url;

    img.onload = function () {
      resolve(url);
    };
    img.onerror = function () {
      reject(url);
    };
  });

export function getTableItems(type = "", item) {
  let res = null;
  switch (type) {
    case "work_weeks":
      res = (
        <tr>
          <td>
            <b>{item?.payroll_frequency?.payroll_name ?? "-"}</b> <br />{" "}
            {item?.payroll_frequency?.payroll_frequency_id ?? "-"}
          </td>
          <td> {item?.start_date ?? "-"} </td>
          <td> {item?.end_date ?? "-"} </td>
          <td> {item?.calendar_days ?? "-"} </td>
          <td> {item?.sundays ?? "-"} </td>
          <td> {item?.saturdays ?? "-"} </td>
          <td> {item?.day_week_5 ?? "-"} </td>
          <td> {item?.day_week_55 ?? "-"} </td>
          <td> {item?.day_week_6 ?? "-"} </td>
        </tr>
      );
      break;

    default:
      break;
  }
  return res;
}

export const getSettingHeaderbar = (
  activeMenu,
  activeSubMenu,
  activeThirdMenu
) => {
  let newSubItems = [];
  let newTopItems = [];
  let newTitle = "";
  let newText = "";
  newTitle = "Settings";
  if (
    [
      "account-settings",
      "user-management",
      "company-settings",
      "account-management",
      "cluster-settings",
      "add-cluster",
    ].includes(activeSubMenu)
  ) {
    newText = "Account Management";
    newTopItems = [
      {
        name: "account-management",
        class: "active_menu",
        title: "Account Management",
      },
    ];
    newSubItems = [
      {
        name: "account-settings",
        class: `link ${
          ["account-settings", "account-management"].includes(activeSubMenu)
            ? " active"
            : ""
        }`,
        title: "Account Settings",
        path: "/settings/account-settings",
      },
      {
        name: "cluster-settings",
        class: `link ${
          ["cluster-settings", "add-cluster"].includes(activeSubMenu)
            ? " active"
            : ""
        }`,
        title: "Cluster Settings",
        path: "/settings/cluster-settings",
      },
      {
        name: "user-management",
        class: `link ${
          ["user-management", "company-settings"].includes(activeSubMenu)
            ? " active"
            : ""
        }`,
        title: "User Management",
        path: "/settings/user-management",
      },
    ];
  } else {
    newTopItems = [
      {
        name: "finance",
        class: `${activeSubMenu == "finance" ? " active_menu" : ""}`,
        title: "Finance",
        path: "/settings/finance",
      },
      {
        name: "order",
        class: `${activeSubMenu == "order" ? " active_menu" : ""}`,
        title: "Orders & Invoices",
        path: "/settings/order",
      },
      {
        name: "labor",
        class: `${activeSubMenu == "labor" ? " active_menu" : ""}`,
        title: "Labor",
        path: "/settings/labor",
      },
      {
        name: "inventory",
        class: `${activeSubMenu == "inventory" ? " active_menu" : ""}`,
        title: "Inventory",
        path: "/settings/inventory",
      },
      {
        name: "onlife-sites-setup",
        class: `${activeSubMenu == "onlife-sites-setup" ? " active_menu" : ""}`,
        title: "Onlife",
        path: "/settings/onlife-sites-setup",
      },
      {
        name: "clipboard",
        class: `${activeSubMenu == "clipboard" ? " active_menu" : ""}`,
        title: "Clipboard",
        path: "/settings/clipboard",
      },
      {
        name: "pos",
        class: `${activeSubMenu == "pos" ? " active_menu" : ""}`,
        title: "POS Master",
        path: "/settings/pos",
      },
      {
        name: "integrations",
        class: `${activeSubMenu == "integrations" ? " active_menu" : ""}`,
        title: "Integration",
        path: "/settings/integrations",
      },
    ];
    switch (activeSubMenu) {
      case "finance":
        newText = "Finance";
        newSubItems = [
          {
            name: "chart-of-accounts",
            class: `link ${activeThirdMenu == "" ? " active" : ""}`,
            title: "General Settings",
            path: "/settings/finance",
          },
          {
            name: "chart-of-accounts",
            class: `link ${
              ["chart-of-accounts"].includes(activeThirdMenu) ? " active" : ""
            }`,
            title: "Chart of Accounts",
            path: "/settings/finance/chart-of-accounts",
          },
          {
            name: "forecast",
            class: `link ${
              ["forecast"].includes(activeThirdMenu) ? " active" : ""
            }`,
            title: "Forecasts",
            path: "/settings/finance/forecast",
          },
          {
            name: "reconcile",
            class: `link ${
              ["reconcile"].includes(activeThirdMenu) ? " active" : ""
            }`,
            title: "Reconcile",
            path: "/settings/finance/reconcile",
          },
        ];
        break;
      case "labor":
        newText = "Labor";
        newSubItems = [
          {
            name: "labor",
            class: `link ${activeThirdMenu == "" ? " active" : ""}`,
            title: "Employees",
            path: "/settings/labor",
          },
          {
            name: "policy",
            class: `link ${
              ["policy"].includes(activeThirdMenu) ? " active" : ""
            }`,
            title: "Labor Policy",
            path: "/settings/labor/policy",
          },
        ];
        break;
      case "order":
        newText = "Orders & Invoices";
        newSubItems = [
          {
            name: "order",
            class: `link ${activeThirdMenu == "" ? " active" : ""}`,
            title: "Order",
            path: "/settings/order",
          },
          {
            name: "invoices",
            class: `link ${
              ["invoices"].includes(activeThirdMenu) ? " active" : ""
            }`,
            title: "Invoices",
            path: "/settings/order/invoices",
          },
          {
            name: "transfer",
            class: `link ${
              ["transfer"].includes(activeThirdMenu) ? " active" : ""
            }`,
            title: "Transfer",
            path: "/settings/order/transfer",
          },
        ];
        break;
      case "inventory":
        newText = "Inventory";
        newSubItems = [
          {
            name: "inventory",
            class: `link ${activeThirdMenu == "" ? " active" : ""}`,
            title: "General",
            path: "/settings/inventory",
          },
          {
            name: "count-settings",
            class: `link ${
              ["count-settings"].includes(activeThirdMenu) ? " active" : ""
            }`,
            title: "Counts",
            path: "/settings/inventory/count-settings",
          },
        ];
        break;
      case "onlife-sites-setup":
        newText = "Onlife";
        break;
      case "clipboard":
        newText = "Clipboard";
        break;
      case "pos":
        newText = "Inventory";
        newSubItems = [
          {
            name: "pos",
            class: `link ${activeThirdMenu == "" ? " active" : ""}`,
            title: "POS Master",
            path: "/settings/pos",
          },
          {
            name: "room-layout",
            class: `link ${
              ["room-layout"].includes(activeThirdMenu) ? " active" : ""
            }`,
            title: "Layout Master",
            path: "/settings/pos/room-layout",
          },
          {
            name: "table-master",
            class: `link ${
              ["table-master"].includes(activeThirdMenu) ? " active" : ""
            }`,
            title: "Table Master",
            path: "/settings/pos/table-master",
          },
          {
            name: "hardware-master",
            class: `link ${
              ["hardware-master"].includes(activeThirdMenu) ? " active" : ""
            }`,
            title: "Hardware Master",
            path: "/settings/pos/hardware-master",
          },
          {
            name: "qr-ordering",
            class: `link ${
              ["qr-ordering"].includes(activeThirdMenu) ? " active" : ""
            }`,
            title: "Qr Ordering",
            path: "/settings/pos/qr-ordering/general",
          },
          {
            name: "ordrr-online",
            class: `link ${
              ["ordrr-online"].includes(activeThirdMenu) ? " active" : ""
            }`,
            title: "Ordrr Online",
            path: "/settings/pos/ordrr-online/general",
          },
          {
            name: "syncs",
            class: `link ${
              ["syncs"].includes(activeThirdMenu) ? " active" : ""
            }`,
            title: "Syncs",
            path: "/settings/pos/syncs",
          },
        ];
        break;
      case "integrations":
        newText = "Integrations";
        newSubItems = [
          {
            name: "integrations",
            class: `link ${activeThirdMenu == "" ? " active" : ""}`,
            title: "Online Ordering",
            path: "/settings/integrations",
          },
          {
            name: "loyalty",
            class: `link ${
              ["loyalty"].includes(activeThirdMenu) ? " active" : ""
            }`,
            title: "Loyalty",
            path: "/settings/integrations/loyalty",
          },
          {
            name: "reservation-table-management",
            class: `link ${
              ["reservation-table-management"].includes(activeThirdMenu)
                ? " active"
                : ""
            }`,
            title: "Reservation & Table Mgmt",
            path: "/settings/integrations/reservation-table-management",
          },
          {
            name: "marketing",
            class: `link ${
              ["marketing"].includes(activeThirdMenu) ? " active" : ""
            }`,
            title: "Marketing & CRM",
            path: "/settings/integrations/marketing",
          },
        ];
        break;
      default:
        break;
    }
  }
  return {
    newSubItems,
    newTopItems,
    newTitle,
    newText,
  };
};

export const getFinanceHeaderbar = (
  activeMenu,
  activeSubMenu,
  activeThirdMenu
) => {
  let newSubItems = [];
  let newTopItems = [];
  let newTitle = "";
  let newText = "";
  newTitle = "Finance";
  newTopItems = [
    {
      name: "sales",
      class: `${activeSubMenu == "sales" ? " active_menu" : ""}`,
      title: "Sales",
      path: "/finance/sales",
    },
    {
      name: "expenses",
      class: `${activeSubMenu == "expenses" ? " active_menu" : ""}`,
      title: "Expenses",
      path: "/finance/expenses",
    },
    {
      name: "payments",
      class: `${activeSubMenu == "payments" ? " active_menu" : ""}`,
      title: "Payments",
      path: "/finance/payments",
    },
    {
      name: "payables",
      class: `${activeSubMenu == "payables" ? " active_menu" : ""}`,
      title: "Payables",
      path: "/finance/payables",
    },
    {
      name: "receivables",
      class: `${activeSubMenu == "receivables" ? " active_menu" : ""}`,
      title: "Receivables",
      path: "/finance/receivables",
    },
    {
      name: "assets",
      class: `${activeSubMenu == "assets" ? " active_menu" : ""}`,
      title: "Assets",
      path: "/finance/assets",
    },
    {
      name: "general-ledger",
      class: `${activeSubMenu == "general-ledger" ? " active_menu" : ""}`,
      title: "General Ledger",
      path: "/finance/general-ledger",
    },
    {
      name: "vouchers",
      class: `${activeSubMenu == "vouchers" ? " active_menu" : ""}`,
      title: "Vouchers",
      path: "/finance/vouchers/voucher-list",
    },
    {
      name: "reconciliation",
      class: `${activeSubMenu == "reconciliation" ? " active_menu" : ""}`,
      title: "Reconciliation",
      path: "/finance/reconciliation",
    },
  ];
  switch (activeSubMenu) {
    case "sales":
      newText = "Sales";
      newSubItems = [
        {
          name: "sales",
          class: `link ${activeThirdMenu == "" ? " active" : ""}`,
          title: "Sales",
          // path: "/finance/sales",
          path: "/finance/sales",
        },
        {
          name: "order-payments",
          class: `link ${activeThirdMenu == "order-payments" ? " active" : ""}`,
          title: "Order & Payments",
          path: "/finance/sales/order-payments",
        },
        {
          name: "refunds",
          class: `link ${activeThirdMenu == "refunds" ? " active" : ""}`,
          title: "Refunds",
          path: "/finance/sales/refunds",
        },
        {
          name: "voids",
          class: `link ${activeThirdMenu == "voids" ? " active" : ""}`,
          title: "VOIDs",
          path: "/finance/sales/voids",
        },
        {
          name: "discounts",
          class: `link ${activeThirdMenu == "discounts" ? " active" : ""}`,
          title: "Discounts",
          path: "/finance/sales/discounts",
        },
        {
          name: "tips",
          class: `link ${activeThirdMenu == "tips" ? " active" : ""}`,
          title: "Tips",
          path: "/finance/sales/tips",
        },
        {
          name: "promotions",
          class: `link ${activeThirdMenu == "promotions" ? " active" : ""}`,
          title: "Promotions",
          path: "/finance/sales/promotions",
        },
      ];
      break;
    case "expenses":
      newText = "Expenses";
      newSubItems = [
        {
          name: "expenses",
          class: `link ${activeThirdMenu == "" ? " active" : ""}`,
          title: "Expenses",
          path: "/finance/expenses",
        },
      ];
      break;
    case "payments":
      newText = "Payments";
      newSubItems = [
        {
          name: "payments",
          class: `link ${activeThirdMenu == "" ? " active" : ""}`,
          title: "Payments",
          path: "/finance/payments",
        },
        {
          name: "new-payment",
          class: `link ${activeThirdMenu == "new-payment" ? " active" : ""}`,
          title: "New Payment",
          path: "/finance/payments/new-payment",
        },
        {
          name: "pending",
          class: `link ${activeThirdMenu == "pending" ? " active" : ""}`,
          title: "Pending Payments",
          path: "/finance/payments/pending",
        },
        {
          name: "approved",
          class: `link ${activeThirdMenu == "approved" ? " active" : ""}`,
          title: "Approved Payments",
          path: "/finance/payments/approved",
        },
        {
          name: "submitted",
          class: `link ${activeThirdMenu == "submitted" ? " active" : ""}`,
          title: "Submitted Payments",
          path: "/finance/payments/submitted",
        },
        {
          name: "rejected",
          class: `link ${activeThirdMenu == "rejected" ? " active" : ""}`,
          title: "Rejected Payments",
          path: "/finance/payments/rejected",
        },
      ];
      break;
    case "payables":
      newText = "Payables";
      newSubItems = [
        {
          name: "payables",
          class: `link ${activeThirdMenu == "" ? " active" : ""}`,
          title: "Outstanding Payables",
          path: "/finance/payables",
        },
        {
          name: "ap-credit-notes",
          class: `link ${
            activeThirdMenu == "ap-credit-notes" ? " active" : ""
          }`,
          title: "AP Credit Notes",
          path: "/finance/payables/ap-credit-notes",
        },
        {
          name: "new-ap-credit-notes",
          class: `link ${
            activeThirdMenu == "new-ap-credit-notes" ? " active" : ""
          }`,
          title: "New AP Credit Notes",
          path: "/finance/payables/ap-credit-notes",
        },
      ];
      break;
    case "receivables":
      newText = "Receivables";
      newSubItems = [
        {
          name: "receivables",
          class: `link ${activeThirdMenu == "" ? " active" : ""}`,
          title: "Receivables",
          path: "/finance/receivables",
        },
        {
          name: "details",
          class: `link ${activeThirdMenu == "details" ? " active" : ""}`,
          title: "Receivable Details",
          path: "/finance/receivables",
        },
        {
          name: "credit_notes",
          class: `link ${activeThirdMenu == "credit_notes" ? " active" : ""}`,
          title: "Credit Notes",
          path: "/finance/receivables/credit_notes",
        },
        {
          name: "incoming_payments",
          class: `link ${
            activeThirdMenu == "incoming_payments" ? " active" : ""
          }`,
          title: "Incoming Payments",
          path: "/finance/receivables/incoming_payments",
        },
      ];
      break;
    case "assets":
      newText = "Assets";
      newSubItems = [
        {
          name: "assets",
          class: `link ${activeThirdMenu == "" ? " active" : ""}`,
          title: "Assets",
          path: "/finance/assets",
        },
        {
          name: "new-asset",
          class: `link ${activeThirdMenu == "new-asset" ? " active" : ""}`,
          title: "New Asset",
          path: "/finance/assets/new-asset",
        },
      ];
      break;
    case "general-ledger":
      newText = "General Ledger";
      newSubItems = [
        {
          name: "general-ledger",
          class: `link ${activeThirdMenu == "" ? " active" : ""}`,
          title: "General Ledger",
          path: "/finance/general-ledger",
        },
        {
          name: "journal-entries",
          class: `link ${
            activeThirdMenu == "journal-entries" ? " active" : ""
          }`,
          title: "Journal Entries",
          path: "/finance/general-ledger/journal-entries",
        },
      ];
      break;
    case "vouchers":
      newText = "Vouchers";
      newSubItems = [
        {
          name: "voucher-list",
          class: `link ${activeThirdMenu == "voucher-list" ? " active" : ""}`,
          title: "Voucher List",
          path: "/finance/vouchers/voucher-list",
        },
        {
          name: "vouchers",
          class: `link ${activeThirdMenu == "" ? " active" : ""}`,
          title: "Vouchers",
          path: "/finance/vouchers",
        },
      ];
      break;
    case "reconciliation":
      newText = "Reconcile";
      newSubItems = [
        {
          name: "reconciliation",
          class: `link ${activeThirdMenu == "" ? " active" : ""}`,
          title: "Accounts",
          // path: "/finance/reconciliation",
        },
      ];
      break;
    default:
      break;
  }
  return {
    newSubItems,
    newTopItems,
    newTitle,
    newText,
  };
};

export const getOrderHeaderbar = (
  activeMenu,
  activeSubMenu,
  activeThirdMenu
) => {
  let newSubItems = [];
  let newTopItems = [];
  let newTitle = "";
  let newText = "";
  newTitle = "ORDERS & INVOICES";
  newTopItems = [
    {
      name: "trade",
      class: `${activeSubMenu == "trade" ? " active_menu" : ""}`,
      title: "Trade Orders",
      path: "/order/trade",
    },
    {
      name: "non-trade",
      class: `${activeSubMenu == "non-trade" ? " active_menu" : ""}`,
      title: "Non-Trade Orders",
      path: "/order/non-trade",
    },
    {
      name: "ap-invoices",
      class: `${activeSubMenu == "ap-invoices" ? " active_menu" : ""}`,
      title: "AP Invoices",
      path: "/order/ap-invoices",
    },
    {
      name: "ar-invoices",
      class: `${activeSubMenu == "ar-invoices" ? " active_menu" : ""}`,
      title: "AR Invoices",
      path: "/order/ar-invoices",
    },
    {
      name: "payees",
      class: `${activeSubMenu == "payees" ? " active_menu" : ""}`,
      title: "Payees",
      path: "/order/payees",
    },
    {
      name: "customers",
      class: `${activeSubMenu == "customers" ? " active_menu" : ""}`,
      title: "Customers",
      path: "/order/customers",
    },
  ];
  switch (activeSubMenu) {
    case "trade":
      newText = "Trade Orders";
      newSubItems = [
        {
          name: "trade",
          class: `link ${activeThirdMenu == "" ? " active" : ""}`,
          title: "Trade Orders",
          path: "/order/trade",
        },
        {
          name: "order-form",
          class: `link ${activeThirdMenu == "order-form" ? " active" : ""}`,
          title: "Order Form",
          path: "/order/trade/order-form",
        },
        {
          name: "orders-pending-approval",
          class: `link ${
            activeThirdMenu == "orders-pending-approval" ? " active" : ""
          }`,
          title: "Orders Pending Approval",
          path: "/order/trade/orders-pending-approval",
        },
        {
          name: "pending-orders",
          class: `link ${activeThirdMenu == "pending-orders" ? " active" : ""}`,
          title: "Pending Orders",
          path: "/order/trade/pending-orders",
        },
        {
          name: "confirmed-orders",
          class: `link ${
            activeThirdMenu == "confirmed-orders" ? " active" : ""
          }`,
          title: "Confirmed Orders",
          path: "/order/trade/confirmed-orders",
        },
        {
          name: "cancelled-orders",
          class: `link ${
            activeThirdMenu == "cancelled-orders" ? " active" : ""
          }`,
          title: "Cancelled Orders",
          path: "/order/trade/cancelled-orders",
        },
      ];
      break;
    case "non-trade":
      newText = "Non Trade Orders";
      newSubItems = [
        {
          name: "non-trade",
          class: `link ${activeThirdMenu == "" ? " active" : ""}`,
          title: "Non-Trade Orders",
          path: "/order/non-trade",
        },
        {
          name: "new-purchase",
          class: `link ${activeThirdMenu == "new-purchase" ? " active" : ""}`,
          title: "New Purchase Requisition",
          path: "/order/non-trade/new-purchase",
        },
        {
          name: "pending-purchase",
          class: `link ${
            activeThirdMenu == "pending-purchase" ? " active" : ""
          }`,
          title: "Pending Purchase Orders",
          path: "/order/non-trade/pending-purchase",
        },
        {
          name: "confirmed-purchase",
          class: `link ${
            activeThirdMenu == "confirmed-purchase" ? " active" : ""
          }`,
          title: "Confirmed Purchase Orders",
          path: "/order/non-trade/confirmed-purchase",
        },
        {
          name: "cancelled-purchase",
          class: `link ${
            activeThirdMenu == "cancelled-purchase" ? " active" : ""
          }`,
          title: "Cancelled Purchase Requisition",
          path: "/order/non-trade/cancelled-purchase",
        },
      ];
      break;
    case "ap-invoices":
      newText = "AP Invoices";
      newSubItems = [
        {
          name: "ap-invoices",
          class: `link ${activeThirdMenu == "" ? " active" : ""}`,
          title: "AP Invoices",
          path: "/order/ap-invoices",
        },
        {
          name: "new-ap-invoices",
          class: `link ${
            activeThirdMenu == "new-ap-invoices" ? " active" : ""
          }`,
          title: "New AP Invoice",
          path: "/order/ap-invoices/new-ap-invoices",
        },
        {
          name: "pending-ap-invoices",
          class: `link ${
            activeThirdMenu == "pending-ap-invoices" ? " active" : ""
          }`,
          title: "Pending AP Invoice",
          path: "/order/ap-invoices/pending-ap-invoices",
        },
        {
          name: "verified-ap-invoices",
          class: `link ${
            activeThirdMenu == "verified-ap-invoices" ? " active" : ""
          }`,
          title: "Verified AP Invoice",
          path: "/order/ap-invoices/verified-ap-invoices",
        },
        {
          name: "cancelled-ap-invoices",
          class: `link ${
            activeThirdMenu == "cancelled-ap-invoices" ? " active" : ""
          }`,
          title: "Cancelled AP Invoice",
          path: "/order/ap-invoices/cancelled-ap-invoices",
        },
      ];
      break;
    case "ar-invoices":
      newText = "AP Invoices";
      newSubItems = [
        {
          name: "ar-invoices",
          class: `link ${activeThirdMenu == "" ? " active" : ""}`,
          title: "AR Invoices",
          path: "/order/ar-invoices",
        },
        {
          name: "new-ar-invoices",
          class: `link ${
            activeThirdMenu == "new-ar-invoices" ? " active" : ""
          }`,
          title: "New AR Invoice",
          path: "/order/ar-invoices/new-ar-invoices",
        },
        {
          name: "outstanding-ar-invoices",
          class: `link ${
            activeThirdMenu == "outstanding-ar-invoices" ? " active" : ""
          }`,
          title: "Outstanding AR Invoice",
          path: "/order/ar-invoices/outstanding-ar-invoices",
        },
        {
          name: "paid-ar-invoices",
          class: `link ${
            activeThirdMenu == "paid-ar-invoices" ? " active" : ""
          }`,
          title: "Paid AR Invoices",
          path: "/order/ar-invoices/paid-ar-invoices",
        },
        {
          name: "cancelled-ar-invoices",
          class: `link ${
            activeThirdMenu == "cancelled-ar-invoices" ? " active" : ""
          }`,
          title: "Cancelled AR Invoice",
          path: "/order/ar-invoices/cancelled-ar-invoices",
        },
      ];
      break;
    case "payees":
      newText = "Payees";
      newSubItems = [
        {
          name: "payees",
          class: `link ${activeThirdMenu == "" ? " active" : ""}`,
          title: "Payees",
          path: "/order/payees",
        },
        {
          name: "new-payee",
          class: `link ${activeThirdMenu == "new-payee" ? " active" : ""}`,
          title: "New Payee",
          path: "/order/payees/new-payee",
        },
        {
          name: "add-payee-pending-approval",
          class: `link ${
            activeThirdMenu == "add-payee-pending-approval" ? " active" : ""
          }`,
          title: "Add Payee Pending Approval",
          path: "/order/payees/add-payee-pending-approval",
        },
      ];
      break;
    case "customers":
      newText = "Customers";
      newSubItems = [
        {
          name: "customers",
          class: `link ${activeThirdMenu == "" ? " active" : ""}`,
          title: "Customers",
          path: "/order/customers",
        },
        {
          name: "new-customer",
          class: `link ${activeThirdMenu == "new-customer" ? " active" : ""}`,
          title: "New Customer",
          path: "/order/customers/new-customer",
        },
      ];
      break;
    default:
      break;
  }
  return {
    newSubItems,
    newTopItems,
    newTitle,
    newText,
  };
};

export const getLaborHeaderbar = (
  activeMenu,
  activeSubMenu,
  activeThirdMenu
) => {
  let newSubItems = [];
  let newTopItems = [];
  let newTitle = "";
  let newText = "";
  newTitle = "LABOR";
  newTopItems = [
    {
      name: "shift",
      class: `${activeSubMenu == "shift" ? " active_menu" : ""}`,
      title: "Shift",
      path: "/labor/shift",
    },
    {
      name: "scheduler",
      class: `${activeSubMenu == "scheduler" ? " active_menu" : ""}`,
      title: "Scheduler",
      path: "/labor/scheduler",
    },
    {
      name: "payroll",
      class: `${activeSubMenu == "payroll" ? " active_menu" : ""}`,
      title: "Payroll",
      path: "/labor/payroll",
    },
    {
      name: "salary-slips",
      class: `${activeSubMenu == "salary-slips" ? " active_menu" : ""}`,
      title: "Salary Slips",
      path: "/labor/salary-slips",
    },
    {
      name: "leave-and-claims",
      class: `${activeSubMenu == "leave-and-claims" ? " active_menu" : ""}`,
      title: "Leave & Claims",
      path: "/labor/leave-and-claims",
    },
  ];
  switch (activeSubMenu) {
    case "shift":
      newText = "Shift";
      newSubItems = [
        {
          name: "shift",
          class: `link ${activeThirdMenu == "" ? " active" : ""}`,
          title: "Shift Manager",
          path: "/labor/shift",
        },
        {
          name: "new-shift",
          class: `link ${activeThirdMenu == "new-shift" ? " active" : ""}`,
          title: "New Shift",
          path: "/labor/shift/new-shift",
        },
        {
          name: "completed-shifts",
          class: `link ${
            activeThirdMenu == "completed-shifts" ? " active" : ""
          }`,
          title: "Completed Shifts",
          path: "/labor/shift/completed-shifts",
        },
        {
          name: "verified-shifts",
          class: `link ${
            activeThirdMenu == "verified-shifts" ? " active" : ""
          }`,
          title: "Verified Shifts",
          path: "/labor/shift/verified-shifts",
        },
      ];
      break;
    case "scheduler":
      newText = "Scheduler";
      break;
    case "payroll":
      newText = "Payroll";
      newSubItems = [
        {
          name: "payroll",
          class: `link ${activeThirdMenu == "" ? " active" : ""}`,
          title: "Payroll",
          path: "/labor/payroll",
        },
        {
          name: "submitted-payrolls",
          class: `link ${
            activeThirdMenu == "submitted-payrolls" ? " active" : ""
          }`,
          title: "Submitted Payrolls",
          path: "/labor/payroll/submitted-payrolls",
        },
        {
          name: "submit-payroll-pending-approval",
          class: `link ${
            activeThirdMenu == "submit-payroll-pending-approval"
              ? " active"
              : ""
          }`,
          title: "Submit Payroll Pending Approval",
          path: "/labor/payroll/submit-payroll-pending-approval",
        },
      ];
      break;

    case "salary-slips":
      newText = "Salary Slips";
      break;
    case "leave-and-claims":
      newText = "Leave & Claims";
      newSubItems = [
        {
          name: "leave-and-claims",
          class: `link ${activeThirdMenu == "" ? " active" : ""}`,
          title: "Requests",
          path: "/labor/leave-and-claims",
        },
        {
          name: "pending-requests",
          class: `link ${
            activeThirdMenu == "pending-requests" ? " active" : ""
          }`,
          title: "Pending Requests",
          path: "/labor/leave-and-claims/pending-requests",
        },
        {
          name: "approved-requests",
          class: `link ${
            activeThirdMenu == "approved-requests" ? " active" : ""
          }`,
          title: "Approved Requests",
          path: "/labor/leave-and-claims/approved-requests",
        },
        {
          name: "rejected-requests",
          class: `link ${
            activeThirdMenu == "rejected-requests" ? " active" : ""
          }`,
          title: "Rejected Requests",
          path: "/labor/leave-and-claims/rejected-requests",
        },
      ];
      break;
    default:
      break;
  }
  return {
    newSubItems,
    newTopItems,
    newTitle,
    newText,
  };
};

export const getMenuHeaderbar = (
  activeMenu,
  activeSubMenu,
  activeThirdMenu
) => {
  let newSubItems = [];
  let newTopItems = [];
  let newTitle = "";
  let newText = "";
  newTitle = "MENU ENGINEER";
  newTopItems = [
    {
      name: "items",
      class: `${activeSubMenu == "items" ? " active_menu" : ""}`,
      title: "Menu Items",
      path: "/menu/items",
    },
    {
      name: "recipes",
      class: `${activeSubMenu == "recipes" ? " active_menu" : ""}`,
      title: "Recipes",
      path: "/menu/recipes",
    },
    {
      name: "ingredients",
      class: `${activeSubMenu == "ingredients" ? " active_menu" : ""}`,
      title: "Ingredients",
      path: "/menu/ingredients",
    },
    {
      name: "pricing",
      class: `${activeSubMenu == "pricing" ? " active_menu" : ""}`,
      title: "Menu Pricing",
      path: "/menu/pricing",
    },
    {
      name: "promotions",
      class: `${activeSubMenu == "promotions" ? " active_menu" : ""}`,
      title: "Promotions",
      path: "/menu/promotions",
    },
  ];
  switch (activeSubMenu) {
    case "items":
      newText = "Menu Items";
      newSubItems = [
        {
          name: "items",
          class: `link ${activeThirdMenu == "" ? " active" : ""}`,
          title: "Menu Items",
          path: "/menu/items",
        },
        {
          name: "new-item",
          class: `link ${activeThirdMenu == "new-item" ? " active" : ""}`,
          title: "New Menu Item",
          path: "/menu/items/new-item",
        },
        {
          name: "categories",
          class: `link ${activeThirdMenu == "categories" ? " active" : ""}`,
          title: "Menu Item Categories",
          path: "/menu/items/categories",
        },
        {
          name: "modifiers",
          class: `link ${activeThirdMenu == "modifiers" ? " active" : ""}`,
          title: "Modifiers",
          path: "/menu/items/modifiers",
        },
      ];
      break;
    case "recipes":
      newText = "Recipes";
      newSubItems = [
        {
          name: "recipes",
          class: `link ${activeThirdMenu == "" ? " active" : ""}`,
          title: "Recipes",
          path: "/menu/recipes",
        },
        {
          name: "new-recipe",
          class: `link ${activeThirdMenu == "new-recipe" ? " active" : ""}`,
          title: "New Recipe",
          path: "/menu/recipes/new-recipe",
        },
        {
          name: "pending-approval",
          class: `link ${
            activeThirdMenu == "pending-approval" ? " active" : ""
          }`,
          title: "Recipes Pending Approval",
          path: "/menu/recipes/pending-approval",
        },
      ];
      break;
    case "ingredients":
      newText = "Ingredients";
      newSubItems = [
        {
          name: "ingredients",
          class: `link ${activeThirdMenu == "" ? " active" : ""}`,
          title: "Ingredients",
          path: "/menu/ingredients",
        },
        {
          name: "new-ingredient",
          class: `link ${activeThirdMenu == "new-ingredient" ? " active" : ""}`,
          title: "New Ingredient",
          path: "/menu/ingredients/new-ingredient",
        },
        {
          name: "pending-approval",
          class: `link ${
            activeThirdMenu == "pending-approval" ? " active" : ""
          }`,
          title: "Ingredients Pending Approval",
          path: "/menu/ingredients/pending-approval",
        },
      ];
      break;
    case "pricing":
      newText = "Menu Pricing";
      newSubItems = [
        {
          name: "pricing",
          class: `link ${activeThirdMenu == "" ? " active" : ""}`,
          title: "Menu Pricing",
          path: "/menu/pricing",
        },
        {
          name: "scheduled-price-update",
          class: `link ${
            activeThirdMenu == "scheduled-price-update" ? " active" : ""
          }`,
          title: "Scheduled Price Update",
          path: "/menu/pricing/scheduled-price-update",
        },
      ];
      break;
    case "promotions":
      newText = "Promotions";
      newSubItems = [
        {
          name: "promotions",
          class: `link ${activeThirdMenu == "" ? " active" : ""}`,
          title: "Promotions",
          path: "/menu/promotions",
        },
        {
          name: "new-promotion",
          class: `link ${activeThirdMenu == "new-promotion" ? " active" : ""}`,
          title: "New Promotion",
          path: "/menu/promotions/new-promotion",
        },
      ];
      break;
    default:
      break;
  }
  return {
    newSubItems,
    newTopItems,
    newTitle,
    newText,
  };
};

export const getInventoryHeaderbar = (
  activeMenu,
  activeSubMenu,
  activeThirdMenu
) => {
  let newSubItems = [];
  let newTopItems = [];
  let newTitle = "";
  let newText = "";
  newTitle = "INVENTORY";
  newTopItems = [
    {
      name: "inventories",
      class: `${activeSubMenu == "inventories" ? " active_menu" : ""}`,
      title: "Inventory",
      path: "/inventory/inventories",
    },
    {
      name: "productions",
      class: `${activeSubMenu == "productions" ? " active_menu" : ""}`,
      title: "Production",
      path: "/inventory/productions",
    },
    {
      name: "wastes",
      class: `${activeSubMenu == "wastes" ? " active_menu" : ""}`,
      title: "Waste",
      path: "/inventory/wastes",
    },
    {
      name: "counts",
      class: `${activeSubMenu == "counts" ? " active_menu" : ""}`,
      title: "Counts",
      path: "/inventory/counts",
    },
  ];
  switch (activeSubMenu) {
    case "inventories":
      newText = "Inventory";
      newSubItems = [
        {
          name: "inventories",
          class: `link ${activeThirdMenu == "" ? " active" : ""}`,
          title: "Inventory",
          path: "/inventory/inventories",
        },
        {
          name: "inventory-log",
          class: `link ${activeThirdMenu == "inventory-log" ? " active" : ""}`,
          title: "Inventory Log",
          path: "/inventory/inventories/inventory-log",
        },
      ];
      break;
    case "productions":
      newText = "Production";
      newSubItems = [
        {
          name: "productions",
          class: `link ${activeThirdMenu == "" ? " active" : ""}`,
          title: "Production Sheet",
          path: "/inventory/productions",
        },
        {
          name: "ad-hoc-checks",
          class: `link ${activeThirdMenu == "ad-hoc-checks" ? " active" : ""}`,
          title: "Check-In / Check-Out",
          path: "/inventory/productions/ad-hoc-checks",
        },
      ];
      break;
    case "wastes":
      newText = "Waste";
      break;
    case "counts":
      newText = "Counts";
      break;
    default:
      break;
  }
  return {
    newSubItems,
    newTopItems,
    newTitle,
    newText,
  };
};
export const getReportingHeaderbar = (
  activeMenu,
  activeSubMenu,
  activeThirdMenu
) => {
  let newSubItems = [];
  let newTopItems = [];
  let newTitle = "";
  let newText = "";
  newTitle = "ANALYTICS & REPORTING";
  newTopItems = [
    {
      name: "finance-summary",
      class: `${activeSubMenu == "finance-summary" ? " active_menu" : ""}`,
      title: "Financial",
      path: "/reporting/finance-summary",
    },
    {
      name: "labor-summary",
      class: `${activeSubMenu == "labor-summary" ? " active_menu" : ""}`,
      title: "Labor",
      path: "/reporting/labor-summary",
    },
    {
      name: "inventory-summary",
      class: `${activeSubMenu == "inventory-summary" ? " active_menu" : ""}`,
      title: "Inventory",
      path: "/reporting/inventory-summary",
    },
    {
      name: "reports",
      class: `${activeSubMenu == "reports" ? " active_menu" : ""}`,
      title: "Reporting",
      path: "/reporting/reports",
    },
  ];
  switch (activeSubMenu) {
    case "finance-summary":
      newSubItems = [
        {
          name: "income",
          class: `link ${activeThirdMenu == "" ? " active" : ""}`,
          title: "Income",
          path: "/reporting/finance-summary",
        },
        {
          name: "expense",
          class: `link ${activeThirdMenu == "expense" ? " active" : ""}`,
          title: "Expense",
          path: "/reporting/finance-summary/expense",
        },
        {
          name: "operations",
          class: `link ${activeThirdMenu == "operations" ? " active" : ""}`,
          title: "Operations",
          path: "/reporting/finance-summary/operations",
        },
        {
          name: "pandl",
          class: `link ${activeThirdMenu == "pandl" ? " active" : ""}`,
          title: "P&L",
          path: "/reporting/finance-summary/pandl",
        },
        {
          name: "balance",
          class: `link ${activeThirdMenu == "balance" ? " active" : ""}`,
          title: "Balance Sheet",
          path: "/reporting/finance-summary/balance",
        },
        {
          name: "cashflow",
          class: `link ${activeThirdMenu == "cashflow" ? " active" : ""}`,
          title: "Cashflow",
          path: "/reporting/finance-summary/cashflow",
        },
      ];
      break;
    case "labor-summary":
      // newText = "Labor";
      break;
    case "inventory-summary":
      newSubItems = [
        {
          name: "inventory-summary",
          class: `link ${activeThirdMenu == "" ? " active" : ""}`,
          title: "Summary",
          path: "/reporting/inventory-summary",
        },
        {
          name: "variance",
          class: `link ${activeThirdMenu == "variance" ? " active" : ""}`,
          title: "Variance",
          path: "/reporting/inventory-summary/variance",
        },
        {
          name: "waste",
          class: `link ${activeThirdMenu == "waste" ? " active" : ""}`,
          title: "Waste",
          path: "/reporting/inventory-summary/waste",
        },
      ];
      break;
    case "reports":
      // newText = "Counts";
      newSubItems = [
        {
          name: "reports",
          class: `link ${activeThirdMenu == "" ? " active" : ""}`,
          title: "Reporting",
          // path: "/reporting/reports",
        },
      ];
      break;
    default:
      break;
  }
  return {
    newSubItems,
    newTopItems,
    newTitle,
    newText,
  };
};
export const getOnlifeHeaderbar = (
  activeMenu,
  activeSubMenu,
  activeThirdMenu
) => {
  let newSubItems = [];
  let newTopItems = [];
  let newTitle = "";
  let newText = "";
  newTitle = "ONLIFE";
  newText = "Summary";
  newTopItems = [
    {
      name: "summary",
      class: `${activeSubMenu == "" ? " active_menu" : ""}`,
      title: "Summary",
      path: "/onlife",
    },
  ];
  return {
    newSubItems,
    newTopItems,
    newTitle,
    newText,
  };
};
export const getClipboardHeaderbar = (
  activeMenu,
  activeSubMenu,
  activeThirdMenu
) => {
  let newSubItems = [];
  let newTopItems = [];
  let newTitle = "";
  let newText = "";
  newTitle = "Clipboard";
  newText = "";
  return {
    newSubItems,
    newTopItems,
    newTitle,
    newText,
  };
};
export const getCodesHeaderbar = (
  activeMenu,
  activeSubMenu,
  activeThirdMenu
) => {
  let newSubItems = [];
  let newTopItems = [];
  let newTitle = "";
  let newText = "";
  newTitle = "SETTINGS";
  newText = "GENERATE CODE";
  newSubItems = [
    {
      name: "codes",
      class: `link active`,
      title: "Add New Code",
      path: "/codes",
    },
  ];
  return {
    newSubItems,
    newTopItems,
    newTitle,
    newText,
  };
};
export const getDashboardHeaderbar = (
  activeMenu,
  activeSubMenu,
  activeThirdMenu
) => {
  let newSubItems = [];
  let newTopItems = [];
  let newTitle = "";
  let newText = "";
  newTitle = "DASHBOARD";
  newText = "";
  newTopItems = [
    {
      name: "dashboard",
      class: ` active_menu`,
      title: "Dashboard",
      path: "/dashboard",
    },
  ];
  return {
    newSubItems,
    newTopItems,
    newTitle,
    newText,
  };
};

export const isChildAccount = (user_details) => {
  let res = false;
  if (user_details?.user?.merchant?.parent_merchant_id > 0) {
    res = true;
  }
  return res;
};

export const getMerchantCurrencySymbol = (user_details) => {
  let res = user_details?.user?.merchant?.currency_symbol ?? "";
  return res;
};

export const searchTextVal = (string, searchVal) => {
  let res = false;
  if (checkNull(string, false)) {
    if (typeof string == "number") {
      string = string.toString();
    }
    res = string.toLowerCase().includes(searchVal);
  }
  return res;
};
export const searchTableHandler = (array, searchVal) => {
  let res = false;
  for (let index = 0; index < array.length; index++) {
    const element = array[index];
    const searchRes = searchTextVal(element, searchVal);
    if (searchRes) {
      res = true;
      break;
    }
  }
  return res;
};

export const editMultiSelectOptions = (valueLabelArray, editValueArray) => {
  const valueLabelArr = valueLabelArray?.map((el) => ({
    value: el?.value?.toString(),
    label: el?.label,
  }));
  const desiredValueArr = editValueArray?.map((el) => el?.toString());

  const ansArr = valueLabelArr?.filter((el) =>
    desiredValueArr?.includes(el?.value)
  );
  return ansArr;
};

export const convertTo24HoursFormat = (timeStr) => {
  const [time, modifier] = timeStr.split(" ");
  let [hours, minutes] = time.split(":");
  if (hours === "12") {
    hours = "00";
  }
  if (modifier === "PM") {
    hours = parseInt(hours, 10) + 12;
  }
  return `${hours}:${minutes}:00`;
};
export function objToArr(obj) {
  const arr = [];
  for (const key in obj) {
    arr.push({
      value: key,
      label: obj[key],
    });
  }
  return arr;
}
export function makeAllObjToArr(obj, exceptedKeys = []) {
  const resultantObj = {
    yes_no: [
      { label: "yes", value: "yes" },
      { label: "no", value: "no" },
    ],
  };
  for (const key in obj) {
    if (
      typeof obj[key] === "object" &&
      obj[key] !== null &&
      !exceptedKeys.includes(key) &&
      !Array.isArray(obj[key])
    ) {
      resultantObj[key] = objToArr(obj[key]);
    } else {
      resultantObj[key] = obj[key];
    }
  }
  return resultantObj;
}

export function downloadTable(tableID, tableName, pageTitle) {
  var divToPrint = document.getElementById(tableID);

  var style = "<style>";
  style = style + "table {width: 100%;font: 17px Calibri;}";
  style =
    style + "table, th, td {border: solid 1px #DDD; border-collapse: collapse;";
  style = style + "padding: 2px 3px;text-align: center;}";
  style = style + "</style>";

  if (tableName) {
    var childEl = document.createElement("h1");
    childEl.innerText = tableName;
    divToPrint.prepend(childEl);
  }

  const newWin = window.open("", "");
  newWin.document.write(`<html><head><title>${pageTitle}</title>`);
  newWin.document.write(style);
  newWin.document.write(divToPrint.outerHTML);
  newWin.print();
  newWin.close();
  if (tableName) divToPrint.firstElementChild.remove();
}
